import React, {FC} from "react";
import {WorkerDay} from "../orders/redux/types";
import {makeStyles} from "@material-ui/core/styles";
import {Button, Typography} from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    calendarEventButton: {
        minWidth: "100%",
    },
    hasOrderAndAvailability: {
        background: theme.palette.warning.light
        // background: `linear-gradient(-45deg, ${theme.palette.primary.main} 50%, ${theme.palette.warning.light} 50%)`
        /*backgroundColor: "linear-gradient(30deg, #013A6B 50%, #004E95 50%)"*/
    },
    hasOnlyOrder: {
        background: theme.palette.warning.light
    },
    hasOnlyAvailability: {
        background: theme.palette.primary.main
        /*backgroundColor: "linear-gradient(30deg, #013A6B 50%, #004E95 50%)"*/
    },
}));

export const WorkerCalendarLegend: FC<{ withoutYellow?: boolean }> = ({withoutYellow}) => {
    const classes = useStyles();
    return (
        <div style={{display: 'flex', marginTop: 40}}>
            <div style={{display: 'flex'}}>
                <Typography variant="caption" color="textSecondary">Verfügbar</Typography>
                <div className={classes.hasOnlyAvailability}
                     style={{marginLeft: 8, width: 16, height: 16, borderRadius: 4}}/>
            </div>
            {!withoutYellow && (
                <div style={{display: 'flex', marginLeft: 16}}>
                    <Typography variant="caption" color="textSecondary">Verfügbar/Gebucht</Typography>
                    <div className={classes.hasOrderAndAvailability}
                         style={{marginLeft: 8, width: 16, height: 16, borderRadius: 4}}/>
                </div>)}
            <div style={{display: 'flex', marginLeft: 16}}>
                <Typography variant="caption" color="textSecondary">Nicht verfügbar</Typography>
                <div style={{marginLeft: 8, width: 16, height: 16, borderRadius: 4, border: 'solid 0.1px grey'}}/>
            </div>
        </div>
    )
}

interface CalendarWorkerEventProps {
    workerDay: WorkerDay;
    onClickDay: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export const WorkerCalendarDayIndicator: FC<CalendarWorkerEventProps> = ({workerDay, onClickDay}) => {

    const classes = useStyles();

    const {orders, availability} = workerDay;

    if (workerDay.orders.length === 0 && workerDay.availability === null) {
        return (
            <></>
        )
    }

    let buttonClass: string | undefined;

    if(orders.filter(o => o.confirmed).length > 0) {
        buttonClass = classes.hasOnlyOrder
    }else if(availability) {
        buttonClass =  classes.hasOnlyAvailability
    }

    // if ((orders.length > 0 || reservations.length > 0) && availability !== null) {
    //     buttonClass = classes.hasOrderAndAvailability;
    // } else {
    //     if (orders.length > 0) {
    //         buttonClass = classes.hasOnlyOrder;
    //     } else if (availability !== null) {
    //         buttonClass = classes.hasOnlyAvailability
    //     }
    // }

    return (
        <Button
            onClick={onClickDay}
            variant={"contained"}
            classes={{
                root: clsx(
                    classes.calendarEventButton,
                    buttonClass
                )
            }}
            size="small"
        />
    )
}
